import styled, { css } from "styled-components";

type BadgeCircleProps = {
  color?: "model" | "primary" | "error" | "light";
};

export const Container = styled.div`
  ${({ theme }) => css`
    width: 52%;
    min-width: 652px;
    height: 100%;
    margin-bottom: 50px;
    padding-left: 30px;
    padding-top: 20px;
    overflow: hidden;

    border-right: 1px solid ${theme.colors.background_light};
  `}
`;

export const Top = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;

    display: flex;
    align-items: center;

    h4 {
      font-size: ${theme.font.sizes.large};
      color: ${theme.colors.title};
      font-weight: ${theme.font.bold};
    }
  `}
`;

export const ButtonClose = styled.button`
  ${({ theme }) => css`
    width: 35px;
    height: 35px;
    background-color: ${theme.colors.background_light};
    border-radius: 10px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 25px;
  `}
`;

export const WrapperDate = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    & > div {
      display: flex;
      align-items: center;
      margin-left: 50px;

      & > div {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: ${theme.colors.text_extra_light};
        margin-right: 6px;
      }
    }

    span {
      color: ${theme.colors.title};
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`;

export const WrapperArchivedText = styled.div`
  ${({ theme }) => css`
    margin-top: 5px;

    p {
      color: ${theme.colors.text_light};
      font-size: 13px;
    }
  `}
`;

export const Content = styled.main`
  width: 92%;
  margin: 40px 0;

  & > div:not(:last-of-type) {
    ${({ theme }) => css`
      margin-bottom: 30px;

      & > span {
        display: block;
        color: ${theme.colors.title};
        font-size: ${theme.font.sizes.xsmall};
        margin-bottom: 8px;
      }
    `}
  }
`;

export const ContentBoxTitle = styled.h4`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.title};
    margin-bottom: 14px;
  `}
`;

export const ContentBoxText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: ${theme.font.sizes.xsmall};
    margin-bottom: 4px;
  `}
`;

export const ContentBoxObservationText = styled.pre`
  ${({ theme }) => css`
    white-space: pre-wrap;
    color: ${theme.colors.text};
    font-size: ${theme.font.sizes.xsmall};
    margin-bottom: 4px;
    font-family: ${theme.font.family};
  `}
`;

export const ServicesTitle = styled.span`
  ${({ theme }) => css`
    display: block;
    color: ${theme.colors.title};
    font-size: ${theme.font.sizes.xsmall};
    margin-bottom: 8px;
  `}
`;

export const Separator = styled.div`
  width: 100%;
  padding: 4px 0;
`;

export const SectionStages = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;

  & > span {
    ${({ theme }) => css`
      display: block;
      margin-bottom: 18px;
      color: ${theme.colors.title};
      font-weight: ${theme.font.bold};
      font-size: ${theme.font.sizes.small};
    `}
  }
`;

export const WrapperButton = styled.div`
  margin-top: 50px;
`;

export const Wrapper = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  & > span {
    ${({ theme }) => css`
      color: ${theme.colors.text};
      font-size: ${theme.font.sizes.small};
    `}
  }
`;

export const WrapperContentService = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  & > div > div {
    margin: 8px 0 10px;
    display: flex;
    align-items: center;

    & > span {
      ${({ theme }) => css`
        color: ${theme.colors.title};
      `}
    }
  }
`;

export const BadgeStatus = styled.div<BadgeCircleProps>`
  ${({ theme, color = "model" }) => css`
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${theme.colors[color]};
    margin-right: 10px;
  `}
`;

export const ServiceScheduleStatusText = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.title};
    font-weight: ${theme.font.bold};
    display: block;
  `}
`;

export const CheckIconImage = styled.img`
  height: 40px;
  width: 40px;
`;

export const Footer = styled.div`
  margin-top: 30px;
  width: 100px;
`;

export const WrapperArchiveButton = styled.div`
  margin-top: 40px;
  width: 92%;
  border-top: 1px solid #707070;
`;

export const ObservationButton = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: 12px;
    text-decoration: underline;
  `}
`;
